import { createSlice } from '@reduxjs/toolkit';
import type { ExternalPlatformsState } from './types';

const initialState: ExternalPlatformsState = {
  platforms: [],
  isLoading: false,
  error: false
};

export const slice = createSlice({
  name: 'externalPlatforms',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getPlatformsSuccess(state, action) {
      state.isLoading = false;
      state.platforms = action.payload;
      state.error = false;
    },
    addPlatformSuccess(state, action) {
      state.platforms = [...state.platforms, action.payload];
      state.isLoading = false;
    },
    upsertPlatformSuccess(state, action) {
      const index = state.platforms.findIndex((p) => p.guid === action.payload.guid);
      if (index !== -1) state.platforms[index] = action.payload;
      state.isLoading = false;
    },
    deletePlatformSuccess(state, action) {
      state.platforms = state.platforms.filter((p) => p.guid !== action.payload);
      state.isLoading = false;
    }
  }
});

export default slice.reducer;
